import getRequest from "../helpers/getRequest";
import {getSnapshot} from "mobx-state-tree";

const loadable = (config) => (self) => {

    return (
        {
            state: {
                loadedFirstTime: false,
                requestInProgress: false,
                error: "",
                after: undefined,
                pageSize: 20,
                hasNext: true,
                sorted_by: "CD",
                cashedFilter: ""
            },
            views: {
                get actualView () {
                    if (!self.loadedFirstTime ||
                        (self.filter && (self.cashedFilter != getSnapshot(self.filter)))
                    )
                    {
                        self.setLoadedFirstTime(true);
                        self.setCashedFilter()
                        self.getFromServer(null)
                        // todo: обработка id
                    }

                        return getSnapshot(self.items)

                },
                get currentPage() {
                    if (self.requestInProgress || self.error)
                        return [];

                    let start = self.after !== undefined ? self.items.findIndex(x => x[self.sorted_by] > self.after) : 0;

                    // We've went past the end of the list
                    if (start === -1) {
                        return [];
                    }

                    return self.items.slice(start, start + this.pageSize);
                },

                get hasPrev() {
                    return self.after !== undefined;
                },

                get ensureNotEmpty () {
                    if (self.items.length == 0 && !this.requestInProgress && !this.error) {
                        self.loadNextPage();
                    }
                }
                },
            actions: {
                setError (error) {
                    self.error = error
                },
                setLoading (loading) {
                    self.requestInProgress = loading
                },
                setItems (items) {
                    self.items.replace(items)
                },
                setLoadedFirstTime (value) {
                  self.loadedFirstTime = value
                },
                setCashedFilter () {
                    self.cashedFilter = getSnapshot(self.filter)
                },
                load () {
                    try {
                        getRequest(config, null, self.setItems, self.setError, self.setLoading).then(() => {})
                    } catch (e) {
                        console.log(e);
                    }
                },
                getFromServer (id) {
                    try {
                        const filter = self.filter?.text64()
                        getRequest({url: config.getUrl(id, filter), method: 'GET'}, null, self.setAll , self.setError, self.setLoading).then(() => {})
                    } catch (e) {
                        console.log(e);
                    }
                },
                postToServer() {
                    try {

                        getRequest({url: config.postUrl(self.id), method: 'POST'}, getSnapshot(self), /*self.setAll*/ null, /*self.setError*/null , null /*self.setLoading*/).then(() => {})
                    } catch (e) {
                        console.log(e);
                    }
                },
                insureServer (id) {
                    console.log(`insure ${id} ${self.id}`)
                    if ((self.id != id) || !(self.loadedFirstTime))
                    {
                        self.id = id
                        self.loadedFirstTime = true;
                        self.getFromServer(id)
                    }
                }
            }})
}

export default loadable
